import { render } from "./NotificationMultipleChoiceQuestionEditPane.vue?vue&type=template&id=a4a76b98&ts=true"
import script from "./NotificationMultipleChoiceQuestionEditPane.vue?vue&type=script&lang=ts"
export * from "./NotificationMultipleChoiceQuestionEditPane.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__